import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const riskApi = {
    classify: async (token, businessDescription) => {
        const res = await axios.post(`${API}/risk/classify`,
            { business_description: businessDescription },
            { headers: getAuthHeader(token) }
        );
        return res.data;
    },

    generateVariants: async (token, proposedName) => {
        const res = await axios.post(`${API}/risk/variants`,
            { proposed_name: proposedName },
            { headers: getAuthHeader(token) }
        );
        return res.data;
    },

    startSearch: async (token, payload) => {
        const res = await axios.post(`${API}/risk/search`, payload, { headers: getAuthHeader(token) });
        return res.data;
    },

    getJobStatus: async (token, jobId) => {
        const res = await axios.get(`${API}/risk/search/${jobId}`, { headers: getAuthHeader(token) });
        return res.data;
    },

    getHistory: async (token) => {
        const res = await axios.get(`${API}/risk/history`, { headers: getAuthHeader(token) });
        return res.data;
    }
};
